module.exports = __webpack_public_path__ + "44d4ca4c953d79e71cad9fad6d409a66.pdf";